import React, { useState, useRef, useEffect } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import imageBorder from "../../assets/images/bestsellerborder.webp";
import { Pagination, useMediaQuery } from "@mui/material";
import moment from "moment";
import BlogSearchBar from "./BlogSearchBar";

const BlogList = ({
  blogpageData,
  currentPage,
  handlePageChange,
  totalPages,
  setmaxrecord,
  maxrecord,
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [visibleCount, setVisibleCount] = useState();

  useEffect(() => {
    if (searchQuery) {
      setVisibleCount(12); // Reset to 12 for new searches
    }
  }, [searchQuery]);

  const displayedData = searchQuery
    ? searchResults.slice(0, visibleCount) // Show only 'visibleCount' search results
    : Array.isArray(blogpageData)
      ? blogpageData.slice()
      : Object.values(blogpageData);

  const parseDate = (dateString) => {
    if (!dateString) return null;
    const sanitizedDate = dateString.replace(
      /(\d{1,2})-(\d{1,2})-(\d{4})/,
      (_, day, month, year) =>
        `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(
          2,
          "0"
        )}`
    );
    return new Date(sanitizedDate);
  };

  const blogBgRef = useRef(null);
  const handlePaginationChange = (event, page) => {
    handlePageChange(event, page);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    if (blogBgRef.current) {
      blogBgRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <>
      <div className="blog-bg py-5">
        {/* {/ <BlogSearchBar setSearchResults={setSearchResults} setSearchQuery={setSearchQuery} /> /} */}

        {/* {/ Wrapper div for Search and Max Record Selector /} */}
        <div className="d-flex flex-column">
          {/* {/ Search Bar /} */}
          <div className="mb-4 search-bar">
            <BlogSearchBar
              setSearchResults={setSearchResults}
              setSearchQuery={setSearchQuery}
              setVisibleCount={setVisibleCount}
            />
          </div>

          {/* {/ Blog maxrecord Selector with gap /} */}
          <div className="d-flex justify-content-end me-4 mt-5">
            <label className="align-content-center blogs-limit fw-medium px-2">
              Blogs Limits :-{" "}
            </label>
            <Form.Select
              aria-label="Select Blog maxrecord"
              value={maxrecord}
              onChange={(e) => setmaxrecord(Number(e.target.value))}
              className="select-limit-blog"
              style={{ width: "170px" }}
            >
              <option value="12">---Select Blogs---</option>
              <option value="10">Show 10</option>
              <option value="20">Show 20</option>
              <option value="50">Show 50</option>
              <option value="100">Show 100</option>
              <option value="150">Show 150</option>
              <option value="200">Show 200</option>
              <option value="300">Show 300</option>
              <option value="500">Show 500</option>
            </Form.Select>
          </div>
        </div>

        <Container className="mt-lg-4 padding-blog">
          <Row>
            <div className="text-center pt-4 saree-heading">
              Our Latest Blog
            </div>
            <div className="d-flex justify-content-center">
              <img
                src={imageBorder}
                className="border-image py-2"
                alt="border"
              />
            </div>
            <div className="d-flex align-items-center justify-content-center px-lg-5">
              <p className="text-center">
                Our team has helped 10,000+ entrepreneurs launch their
                businesses worldwide...
              </p>
            </div>

            {/* {/ Blog List with View More/Less /} */}
            {displayedData.length > 0 ? (
              displayedData.slice(0, visibleCount).map((blog, i) => {
                const blogDate = parseDate(blog?.created_at);
                const staticDate = moment("01-02-2025", "DD-MM-YYYY");
                const blogMoment = moment(blogDate);

                let finalUrl;

                if (
                  !blogMoment.isValid() ||
                  blogMoment.isSameOrBefore(staticDate)
                ) {
                  const year = blogMoment.year();
                  const month = String(blogMoment.month() + 1).padStart(2, "0");
                  const day = String(blogMoment.date()).padStart(2, "0");

                  finalUrl = `/${year}/${month}/${day}/${blog?.url
                    .replace(/\s+/g, "-")
                    .replace(/\u200C/g, '')
                    .toLowerCase()}`;
                } else {
                  // finalUrl = `/blog/${blog?.url
                  finalUrl = `/${blog?.url
                    .replace(/\s+/g, "-")
                    .replace(/\u200C/g, '')
                    .toLowerCase()}`;
                }

                return (
                  <Col lg={4} md={6} sm={12} className="mb-4 mt-lg-2" key={i}>
                    <div className="d-flex justify-content-center">
                      <Card
                        className="text-dark bloglist them-borderradius theme-shadow"
                        style={{ width: "24rem" }}
                      >
                        <div onClick={() => window.open(finalUrl, "_blank")} style={{cursor:"pointer"}}>
                          <Card.Img
                            variant="top"
                            src={blog.image}
                            className="card-radius img-fluid"
                            alt={`blog-image-${i}`}
                            style={{ aspectRatio: "10/5" }}
                          />
                          <Card.Body>
                            <p className="text-center text-wrap">
                              {blog.description || blog.blog_name}
                            </p>
                          </Card.Body>
                        </div>
                      </Card>
                    </div>
                  </Col>
                );
              })
            ) : (
              <div className="p-4 text-center fw-bold not-found">
                No Blogs Found
              </div>
            )}

            {/* {/ View More / View Less Buttons /} */}
            {searchQuery && displayedData.length > 0 && (
              <div className="text-center mt-3">
                {visibleCount < searchResults.length ? (
                  // <Button
                  //   variant="danger"
                  //   onClick={() => setVisibleCount((prev) => prev + 12)}
                  // >
                  //   View More
                  // </Button>

                  <button
                    className="btn-red-to-black-color-move rounded-4"
                    onClick={() => setVisibleCount((prev) => prev + 12)}
                  >
                    <span> View More</span>
                  </button>
                ) : (
                  // <Button variant="dark" onClick={() => setVisibleCount(12)}>
                  //   View Less
                  // </Button>
                  <button
                    className="btn-red-to-black-color-move rounded-4"
                    onClick={() => setVisibleCount(12)}
                  >
                    <span> View Less</span>
                  </button>
                )}
              </div>
            )}
            {/* {/ Pagination (Only show if not searching) /} */}
            {!searchQuery && (
              <div className="pagination-controls">
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  onChange={handlePaginationChange}
                  variant="outlined"
                  shape="rounded"
                  siblingCount={1}
                  boundaryCount={isMobile ? 0 : 1}
                  showFirstButton={!isMobile}
                  showLastButton={!isMobile}
                  sx={{
                    display: "flex",
                    flexWrap: "nowrap",
                    overflowX: "auto",
                    "& .MuiPaginationItem-root": {
                      backgroundColor: "black",
                      color: "white",
                      "&:hover": {
                        backgroundColor: "#333",
                      },
                    },
                    "& .Mui-selected": {
                      backgroundColor: "red",
                      color: "white",
                      "&:hover": {
                        backgroundColor: "darkred",
                      },
                    },
                  }}
                />
              </div>
            )}
          </Row>
        </Container>
      </div>
    </>
  );
};

export default BlogList;